<div class="container py-3">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  }

  @if (!isLoading) {
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="153"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <div class="row mb-3">
      <ziro-collapsible-section-card
        [isSwitchHidden]="true"
        [isCollapsible]="false"
        [title]="callQueue.name"
        [subtext]="'tkey;migrations.ring_central.call_queues.detail.general.description'"
        [icon]="ziroIcons.CALL_QUEUE"
        class="col"
      >
        <div class="px-3 py-2 d-flex justify-content-between align-items-center">
          <strong>{{ 'tkey;migrations.ring_central.call_queues.detail.phone_number.label' | translate }}</strong>
          <span>{{ directNumbers }}</span>
        </div>
        <div class="px-3 py-2 d-flex justify-content-between align-items-center">
          <strong>{{ 'tkey;migrations.ring_central.call_queues.detail.extension.label' | translate }}</strong>
          <span>{{ callQueue.number }}</span>
        </div>
      </ziro-collapsible-section-card>

      <!-- Routing Settings -->
      <ziro-collapsible-section-card
        [isSwitchHidden]="true"
        [isCollapsible]="false"
        [title]="'tkey;migrations.ring_central.call_queues.detail.routing_settings.title'"
        [subtext]="'tkey;migrations.ring_central.call_queues.detail.routing_settings.description'"
        [icon]="ziroIcons.GEAR_COMPLEX"
        [class]="'col'"
      >
        <div class="px-3 py-2 d-flex justify-content-between align-items-center">
          <strong>
            {{ 'tkey;migrations.ring_central.call_queues.detail.routing_settings.routing_method.label' | translate }}
          </strong>
          <span>
            {{ getRoutingMethodTkey(callQueue.routingMethod) | translate }}
          </span>
        </div>
        <div class="px-3 py-2 d-flex justify-content-between align-items-center">
          <strong>
            {{ 'tkey;migrations.ring_central.call_queues.detail.routing_settings.alert_timer.label' | translate }}
          </strong>
          <span>{{ callQueue.alertTimer }}</span>
        </div>
        <div class="px-3 py-2 d-flex justify-content-between align-items-center">
          <strong>
            {{
              'tkey;migrations.ring_central.call_queues.detail.routing_settings.agents_can_opt_out.label' | translate
            }}
          </strong>
          <span>
            {{
              callQueue.canAgentsOptOutOfQueue
                ? ('tkey;migrations.ring_central.call_queues.detail.routing_settings.can_opt_out.yes' | translate)
                : ('tkey;migrations.ring_central.call_queues.detail.routing_settings.can_opt_out.no' | translate)
            }}
          </span>
        </div>
      </ziro-collapsible-section-card>
    </div>

    <!-- Greeting & Hold Music -->
    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;migrations.ring_central.call_queues.detail.audio_settings.title'"
      [subtext]="'tkey;migrations.ring_central.call_queues.detail.audio_settings.description'"
      [icon]="ziroIcons.ANNOUNCEMENTS"
    >
      <div class="d-flex p-4 gap-4">
        <div class="d-flex flex-column w-100">
          <label class="fw-semibold mb-2">
            {{ 'tkey;migrations.ring_central.call_queues.detail.audio_settings.intro_greeting.label' | translate }}
          </label>
          @if (greetingAudioUrl) {
            <div class="d-flex align-items-center gap-2">
              <audio
                [attr.data-automation]="'greeting-audio-readonly'"
                class="flex-grow-1"
                controls
                [src]="greetingAudioUrl"
                [title]="greetingDownloadName"
              ></audio>
              <a [href]="greetingAudioUrl" [download]="greetingDownloadName" class="btn btn-border btn-link p-0">
                <i [class]="ziroIcons.DOWNLOAD_SMALL + ' font-size-18'"></i>
              </a>
            </div>
          } @else {
            <span class="text-muted">
              {{ 'tkey;migrations.ring_central.call_queues.detail.audio_settings.use_default_greeting' | translate }}
            </span>
          }
        </div>
        <div class="d-flex flex-column w-100">
          <label class="fw-semibold mb-2">
            {{ 'tkey;migrations.ring_central.call_queues.detail.audio_settings.hold_music.label' | translate }}
          </label>
          @if (musicOnHoldAudioUrl) {
            <div class="d-flex align-items-center gap-2">
              <audio
                [attr.data-automation]="'moh-audio-readonly'"
                class="flex-grow-1"
                controls
                [src]="musicOnHoldAudioUrl"
                [title]="musicOnHoldDownloadName"
              ></audio>
              <a [href]="musicOnHoldAudioUrl" [download]="musicOnHoldDownloadName" class="btn btn-border btn-link p-0">
                <i [class]="ziroIcons.DOWNLOAD_SMALL + ' font-size-18'"></i>
              </a>
            </div>
          } @else {
            <span class="text-muted">
              {{ 'tkey;migrations.ring_central.call_queues.detail.audio_settings.none' | translate }}
            </span>
          }
        </div>
      </div>
    </ziro-collapsible-section-card>

    <!-- Error Handling -->
    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;migrations.ring_central.call_queues.detail.error_handling.title'"
      [subtext]="'tkey;migrations.ring_central.call_queues.detail.error_handling.description'"
      [icon]="ziroIcons.CIRCLE_EXCLAMATION"
    >
      <div class="px-3 py-2 d-flex gap-3">
        <fieldset class="flex-fill rc-call-queue-fieldset">
          <legend class="rc-call-queue-legend">
            <strong>
              {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.max_callers.label' | translate }}
            </strong>
          </legend>
          <div class="d-flex justify-content-between align-items-center">
            <strong>
              {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.action.label' | translate }}
            </strong>
            <span>
              {{ getOverflowActionTkey(callQueue.errorHandling.callOverflowAction) | translate }}
            </span>
          </div>
          @if (callQueue.errorHandling.callOverflowDestination) {
            <div class="d-flex justify-content-between align-items-center mt-1">
              <strong>
                {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.destination.label' | translate }}
              </strong>
              <span>{{ callQueue.errorHandling.callOverflowDestination }}</span>
            </div>
          }
        </fieldset>
        <fieldset class="flex-fill rc-call-queue-fieldset">
          <legend class="rc-call-queue-legend">
            <strong>
              {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.max_wait_time.label' | translate }}
            </strong>
          </legend>
          <div class="d-flex justify-content-between align-items-center">
            <strong>
              {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.action.label' | translate }}
            </strong>
            <span>
              {{ getTimeoutActionTkey(callQueue.errorHandling.callTimeoutAction) | translate }}
            </span>
          </div>
          @if (callQueue.errorHandling.callTimeoutDestination) {
            <div class="d-flex justify-content-between align-items-center mt-1">
              <strong>
                {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.destination.label' | translate }}
              </strong>
              <span>{{ callQueue.errorHandling.callTimeoutDestination }}</span>
            </div>
          }
        </fieldset>
        <fieldset class="flex-fill rc-call-queue-fieldset">
          <legend class="rc-call-queue-legend">
            <strong>
              {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.no_agents.label' | translate }}
            </strong>
          </legend>
          <div class="d-flex justify-content-between align-items-center">
            <strong>
              {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.action.label' | translate }}
            </strong>
            <span>
              {{ getNoAgentsActionTkey(callQueue.errorHandling.noAgentsAction) | translate }}
            </span>
          </div>
          @if (callQueue.errorHandling.noAgentsDestination) {
            <div class="d-flex justify-content-between align-items-center mt-1">
              <strong>
                {{ 'tkey;migrations.ring_central.call_queues.detail.error_handling.destination.label' | translate }}
              </strong>
              <span>{{ callQueue.errorHandling.noAgentsDestination }}</span>
            </div>
          }
        </fieldset>
      </div>
    </ziro-collapsible-section-card>

    <!-- Members -->
    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;migrations.ring_central.call_queues.detail.members.title'"
      [subtext]="'tkey;migrations.ring_central.call_queues.detail.members.description'"
      [icon]="ziroIcons.GROUP"
    >
      <ziro-datatable
        [dataAutomation]="'ring-central-call-queue-members-table'"
        [columns]="memberColumns"
        [rowDataSource]="memberRows"
        [uniqueRowIdentifier]="null"
      ></ziro-datatable>
    </ziro-collapsible-section-card>
  }
</div>
